module.exports = __webpack_public_path__ + "static/media/pause.bddd0db3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/pause.svg
// module id = 167
// module chunks = 0